import React, { useRef, useState } from "react";
import SignatureCanvas from "react-signature-canvas";
import "../style/Tools/NewSignature.css";

const NewSignature = ({ onSignatureSave }) => {
  const sigCanvas = useRef(null);
  const [signatureURL, setSignatureURL] = useState(null);

  const saveSignature = () => {
    if (sigCanvas.current.isEmpty()) {
      alert("Please provide a signature first!");
    } else {
      const dataURL = sigCanvas.current.toDataURL();
      setSignatureURL(dataURL);
      if (onSignatureSave) {
        onSignatureSave(dataURL); // Send the signature URL to the parent
      }
    }
  };

  const clearSignature = () => {
    sigCanvas.current.clear();
    setSignatureURL(null);
    if (onSignatureSave) {
      onSignatureSave(null); // Clear the signature in the parent
    }
  };

  return (
    <div className="new-signature-container">
      {/* <h2 className="title">New Electronic Signature</h2> */}
      <SignatureCanvas
        ref={sigCanvas}
        penColor="black"
        canvasProps={{
          width: 500,
          height: 200,
          className: "signatureCanvas",
        }}
      />
      <div className="button-container">
        <button onClick={saveSignature} className="button save-button">
          Save Signature
        </button>
        <button onClick={clearSignature} className="button clear-button">
          Clear Signature
        </button>
      </div>
      {signatureURL && (
        <div className="output-container">
          <div className="signature-display">
            <img
              src={signatureURL}
              alt="Saved Signature"
              className="signature-image"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default NewSignature;